import { toast } from 'react-toastify';
import appApi from '../../../../../../api/app-api';
import { displayErrorText } from '../../../../../../api/errors/api-error-codes';
import { AccountingDepositEntity } from '../../../../../../api/types/accounting/accounting-deposit-entity';
import { AccountingDepositPaymentDetailsEntity } from '../../../../../../api/types/accounting/accounting-deposit-payment-details-entity';

export const getDepositDetailsOperation = async (
  depositId: number,
  offset: number,
  limit: number,
  setDeposit: (deposit: AccountingDepositEntity | null) => void,
  setPayments: (payments: AccountingDepositPaymentDetailsEntity[]) => void,
  setTotal: (total: number) => void,
  setLoading: (loading: boolean) => void,
) => {
  try {
    setLoading(true);

    const res = await appApi.getAccountingDepositById(depositId, offset, limit);

    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setLoading(false);
      return;
    }

    setDeposit(res.data.body.deposit ?? null);
    setPayments(res.data.body.payments?.data ?? []);
    setTotal(res.data.body.payments?.total ?? 0);
    setLoading(false);
  } catch (e) {
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
    setLoading(false);
  }
};
